import { render, staticRenderFns } from "./popular-search-edit.vue?vue&type=template&id=af7ca322&"
import script from "./popular-search-edit.vue?vue&type=script&lang=js&"
export * from "./popular-search-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports